export default __webpack_public_path__ + "resources/icons/d121-de6c.webp";